// extracted by mini-css-extract-plugin
export default {"footerCookie":"styles_footerCookie__h6i4+","footerCookieText":"styles_footerCookieText__gwfSi","footerButton":"styles_footerButton__d7rte"};